import Paragraphs from "./Paragraphs";

function PhotoAndText(props) {
    return (
        <div className={`bg-white rounded-2xl m-auto flex flex-col ${props.vertical ? "" : "lg:flex-row"} `}>
            <div className={`w-full ${props.vertical ? "lg:w-full" : "lg:w-1/3"} `}>
                <img
                    src={props.image}
                    alt="Event"
                    className={`object-cover w-full h-full rounded-tl-2xl  rounded-tr-2xl ${props.vertical ? "":"lg:rounded-bl-2xl lg:rounded-tr-none"} ${props.imgPadding ? "p-4" : ""}`}
                />
            </div>
            <div className={`w-full ${props.vertical ? "lg:w-full" : "lg:w-2/3"} p-8 text-blue-dark flex flex-col justify-between`}>
                <div>
                    {props.title &&
                        <div className="text-3xl text-golden font-bold mb-4">
                            {props.title}
                        </div>
                    }
                    {props.paragraphs && <Paragraphs paragraphs={props.paragraphs} />}
                    {props.content}
                </div>
            </div>

        </div>
    );
}

export default PhotoAndText;
